<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount } from "vue";
import { useRouter } from "vue-router";

const componentName = "UnknownRoute";

export default defineComponent({
  name: componentName,
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      router.push("/home");
    });

    return {};
  },
});
</script>
